import { extendTheme } from "@chakra-ui/react"

export const ptExtendTheme = (props) => extendTheme(props)
